import { create } from 'zustand';
var useContentNodeStore = create(function (set) { return ({
    contentNode: null,
    setContentNode: function (contentNode) { return set({ contentNode: contentNode }); },
}); });
var contentNodeSelector = function (store) { return store.contentNode; };
var setContentNodeSelector = function (store) {
    return store.setContentNode;
};
export var useGetContentNode = function () { return useContentNodeStore(contentNodeSelector); };
export var useSetContentNode = function () {
    return useContentNodeStore(setContentNodeSelector);
};
//# sourceMappingURL=useContentNode.js.map